import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import usePagination from './usePagination';
import { getUsers } from 'services/users';

const id = 'users';

export const useUsers = (types = [], search = '', clinicUuid = null) => {
    const {
        paginationModel,
        setPaginationModel,
        rowsPerPageOptions,
        count,
        currentToken,
        resolveHeader
    } = usePagination();

    const handlerFetchData = async ({ queryKey }) => {
        const [, { types, search, clinicUuid }] = queryKey;

        return getUsers(
            types,
            paginationModel.pageSize,
            currentToken(paginationModel.page),
            search,
            clinicUuid
        );
    };

    const { isPending, isError, data } = useQuery({
        queryKey: [
            id,
            {
                types,
                search,
                clinicUuid,
                paginationModel
            }
        ],
        queryFn: handlerFetchData,
        keepPreviousData: true
    });

    useEffect(() => {
        if (data) {
            resolveHeader(data.headers, paginationModel.page);
        }
    }, [data]);

    return {
        data: data?.data || [],
        isLoading: isPending,
        error: isError,
        count,
        rowsPerPageOptions,
        paginationModel,
        setPaginationModel
    };
};
